import React from 'react';
import { graphql } from "gatsby"
import { Asset } from "../../../../plugins/gatsby-plugin-atollon"
import StructuredText from "../custom-structured-text-renderer"
import parse from "html-react-parser";

const QuoteContent = ({subtitle, title, image, quote, name, richContent, special}) => {
  return (
    <section className='quote-content'>
      <div className='quote-content__inner'>
        {subtitle && <span>{parse(subtitle)}</span>}
        {title && <h2>{parse(title)}</h2>}
        {image && <Asset asset={image} />}
        {quote && <StructuredText as='h3' data={quote} />}
        {name && <h4>{parse(name)}</h4>}
        {richContent && <StructuredText data={richContent} />}
      </div>
    </section>
  )
}

export default QuoteContent

export const query = graphql`
  fragment QuoteContentProps on DatoCmsQuoteContent {
    ... on DatoCmsQuoteContent {
      id
      title
      subtitle
      name
      image {
        ...InternalAssetProps
      }
      quote {
        value
      }
      richContent {
        value
      }
      special
    }
  }
`